import React, { Fragment, useEffect, useState } from "react";
import { Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import Styles from "../DetailParcelle.scss";

const DataBati = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [asData, setAsData] = useState(false);
   const [items, setItems] = useState([]);

   useEffect(() => {
      props.detailKeyPar ? fetchData() : null;
   }, [props.detailKeyPar]);

   useEffect(() => {
      items.length > 0 ? setAsData(true) : setAsData(false);
   }, [items]);

   const fetchData = () => {
      setIsLoading(true);
      const params = {
         key_parcelles: [props.detailKeyPar],
      };
      axios
         .post("/Api/geodata/vmap/parcelle/bati", params)
         .then((result) => {
            setItems(result.data);
            setIsLoading(false);
         })
         .catch((err) => {
            console.log(err);
         });
   };

   const onHandleClick = (invariant, idLoc) => {
      props.detailCurrentLot(invariant);
      //props.detailIdLocal(idLoc)
      props.showTab("detailFiscale");
   };

   const renderItems = (item, index) => {
      // console.log(item, "info bati");
      return (
         <tr key={index}>
            <td>
               <OverlayTrigger
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip id="button-tooltip">Informations fiscales</Tooltip>}
                  placement={"top"}
               >
                  <button className={"btn btn-primary btn-sm"} onClick={(e) => onHandleClick(item.invar)}>
                     <i className="far fa-file-alt fa-1x text-light"></i>
                  </button>
               </OverlayTrigger>
            </td>

            <td>{item?.invar}</td>
            <td style={{ whiteSpace: "pre-line" }}>{item?.proprietaire}</td>
            <td>{item?.type}</td>
            <td style={{ wordBreak: "break-all" }}>{item?.date_acte}</td>
         </tr>
      );
   };

   return (
      <div id={"majic-proprio"}>
         {asData ? (
            <Fragment>
               <div className={"section section-data card ueThemeBackground ueColorBase border-0"}>
                  <div className="card-body">
                     <div className="ue-detail-parcelle-section-title" style={{ fontWeight: "bold" }}>
                        Elément Bâti
                     </div>
                     <table
                        className="table table-condensed ue-table-data"
                        style={{ width: "100%", fontSize: "0.65rem" }}
                     >
                        <thead
                           style={{
                              wordBreak: "initial",
                              color: "#70989A",
                           }}
                           className={"text-center"}
                        >
                           <tr>
                              <th>Info</th>
                              <th>Invariant</th>
                              <th className={"text-left"}>Proprietaire imposable</th>
                              <th>Type</th>
                              <th>Mutation</th>
                           </tr>
                        </thead>
                        <tbody className={"text-left"}>
                           {items
                              ? items.map((item, index) => {
                                   return renderItems(item, index);
                                })
                              : null}
                        </tbody>
                     </table>
                  </div>
               </div>
            </Fragment>
         ) : isLoading ? (
            <div className="text-center my-2">
               <Spinner animation="border" size={"sm"} />
            </div>
         ) : (
            <div></div>
         )}
         <br /> <br />
         <div style={{ height: "2rem" }}></div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      detailKeyPar: state.LeftPanelReducer.detailKeyPar,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      showTab: (e) => dispatch({ type: "TOGGLE_PANEL_TAB", data: { currentTab: e } }),
      detailCurrentLot: (e) => dispatch({ type: "TOGGLE_DETAIL_LOT", data: { currentLot: e } }),
      detailIdLocal: (e) => dispatch({ type: "SET_ID_LOCAL", data: { idLocal: e } }),
   };
};
export default connect(mapStateToProps, mapDispatchTProps)(DataBati);
